<header class="text-primary fw-bold text-center" [style.margin-bottom.px]="12">
  Siga o Tele Prêmios da Sorte
</header>
<ul class="d-flex gap-4 justify-content-center mb-0">
  @for (item of socialMediaList$ | async; track $index) {
    <li>
      <a
        [attr.id]="'footerSocialMedia-' + $index"
        class="link-rede-social text-primary"
        [attr.aria-label]="'footer-rede-social-' + $index"
        [href]="item.href"
        target="_blank"
        rel="noopener">
        <figure class="mb-0">
          <picture>
            <img
              class="silvio-santos-holding__logo"
              [src]="item.image"
              [alt]="item.title" />
          </picture>
        </figure>
      </a>
    </li>
  }
</ul>
